export class StoreProductGroupMemberDetails {
    public productId = 0;
    public productImageUrl = "";
    public productName = "";
    public isSelected = false;
    public isInCart = false;
    public relatedProcessProductIds: number[] = [];
    public enabled = false;

    constructor(details: StoreProductGroupMemberDetails) {
        this.productId = details.productId;
        this.productImageUrl = details.productImageUrl;
        this.productName = details.productName;
        this.enabled = details.enabled;
    }
}
